module.exports = __webpack_public_path__ + "img/1.cce01959.png";